export const baseUrl = "https://api.themoviedb.org/3";
export const  API_KEY = "c025c82c638e03ebd2fdc3dbfab1edfa";
export const imageUrl = 'https://image.tmdb.org/t/p/original'